import gql from 'graphql-tag';

export default gql`
    query ExportDriverMessagesByDriverId($input: ExportDriverMessageQueryInput) {
        exportDriverMessagesByDriverId(input: $input) {
            csvDownloadUrl
        }
    }
`;
